module.exports = __webpack_public_path__ + "img/1.f4c6ed4a.jpg";